var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-plyr',{staticClass:"video-elem"},[_c('div',{attrs:{"data-plyr-provider":_vm.source,"data-plyr-embed-id":_vm.video}})])}
var staticRenderFns = []

export { render, staticRenderFns }